/**
 * ViewAsClientBanner
 *
 * Phase D: Shown when an admin is viewing the dashboard as a specific client.
 * Displays "Viewing as: {name}" with a back button to return to Admin Agents.
 */

import { ArrowLeft, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAgent } from "@/contexts/AgentContext";
import { useViewAs } from "@/hooks/useViewAs";

export function ViewAsClientBanner() {
  const { isViewingAs, exitViewAs } = useViewAs();
  const { state } = useAgent();

  if (!isViewingAs) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye className="w-4 h-4" />
        <span>
          Viewing as: <strong>{state.profile.name || "Loading..."}</strong>
          {state.profile.company && (
            <span className="opacity-80 ml-1">({state.profile.company})</span>
          )}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={exitViewAs}
        className="text-white hover:bg-amber-600 hover:text-white gap-1.5 h-7"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Back to Admin
      </Button>
    </div>
  );
}
